import { render, staticRenderFns } from "./retrieve_auth_code.vue?vue&type=template&id=1214dcea&scoped=true&"
import script from "./retrieve_auth_code.vue?vue&type=script&lang=js&"
export * from "./retrieve_auth_code.vue?vue&type=script&lang=js&"
import style0 from "./retrieve_auth_code.vue?vue&type=style&index=0&id=1214dcea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1214dcea",
  null
  
)

export default component.exports